import { Else, If, Then } from "react-if";
import styles from "./index.module.less";
// import InfiniteScroll from "react-infinite-scroll-component";
import useAppStore from "@/context/store";
import { useMemoizedFn } from "ahooks";
import classNames from "classnames";
import { useEffect, useMemo, useRef, useState } from "react";
import HBLoading from "../HBLoading";
import InfiniteScroll from "../InfiniteScroll";
import { useLogin } from "../LoginModal";
import Masonry from "../Masonry";
/**
 * @param {{
 *   disableMasonry?: boolean;
 *   dataSource: any[];
 *   render: (record: any, index: number) => any;
 *   onLoadMore?: (record: any) => any;
 *   children?: any;
 *   hasMore?: boolean;
 *   scrollableTarget?: any;
 *   endMessage?: any;
 *   infiniteScrollOptions?: any;
 *   masonryOptions?: any;
 *   uniqueKey: string;
 *   loginGuide?: boolean;
 *   masonryRef?: any;
 *   listStyle?: any;
 *   filter?: any;
 *   className?: string;
 * }} query
 * @returns {any}
 */
export default function HBList({
  disableMasonry,
  dataSource = [],
  render,
  onLoadMore,
  children,
  hasMore = true,
  scrollableTarget,
  endMessage,
  infiniteScrollOptions,
  masonryOptions,
  uniqueKey,
  loginGuide,
  masonryRef,
  listStyle = {},
  filter = null,
  className = "",
  loadingContent = null,
}) {
  const { login } = useLogin();
  const listRef = useRef(null);
  const [dataLength, setDataLength] = useState(dataSource.length);
  const [loginDataNumber, setLoginDataNumber] = useState(0);
  const [loginNumberInit, setLoginNumberInit] = useState(false);
  const newDataSource = useMemo(() => {
    if (filter) {
      return filter(dataSource);
    }
    return dataSource;
  }, [dataSource, filter]);
  const renderList = useMemo(() => {
    const list = [];

    let index = 0;
    newDataSource.reduce((map, record) => {
      if (uniqueKey) {
        if (!map[record[uniqueKey]]) {
          list.push(render(record, index++));
          map[record[uniqueKey]] = true;
        }
      } else {
        list.push(render(record, index++));
      }

      return map;
    }, {});

    if (children) {
      list.unshift(children);
    }

    return list;
  }, [children, newDataSource, uniqueKey, render]);

  // useEffect(() => {
  //   if (dataSource.length > 0) {
  //     if (scrollableTarget) {
  //       const target =
  //         typeof scrollableTarget === "string"
  //           ? document.getElementById(scrollableTarget)
  //           : scrollableTarget;
  //       listRef.current.throttledOnScrollListener({ target });
  //     } else {
  //       listRef.current.throttledOnScrollListener();
  //     }
  //   }
  // }, [dataSource, scrollableTarget]);
  const { user, userReady } = useAppStore(({ user, userReady }) => ({
    user,
    userReady,
  }));

  const endMsg = useMemo(() => {
    if (endMessage === undefined) {
      if (loginGuide && userReady && !user) {
        return (
          <div
            className={styles.endMessage}
            data-gd-click="button_click"
            data-button-name="注册或登录"
            data-content-source="底部栏"
          >
            <span onClick={login}>注册或登录</span>
            可查看更多优质内容哦~
          </div>
        );
      }
      return (
        <p className={classNames([styles.noMore, "noMore"])}>没有更多了</p>
      );
    } else {
      return endMessage;
    }
  }, [endMessage, loginGuide, user, userReady, login]);

  // https://jira.huanleguang.com/browse/HUABAN-1719
  // 登录触发时机实验
  // const [loginDataNumber, setLoginDataNumber] = useState(100);

  const loginGuideMore = useMemo(() => {
    if (!loginNumberInit && dataSource?.length) {
      // 由于每个页面请求数量不同，触发登录弹窗条件为初次请求的量*2，即为两屏展示
      setLoginNumberInit(true);
      setLoginDataNumber(dataSource?.length * 2);
      return true;
    }
    if (
      loginGuide &&
      !user &&
      userReady &&
      loginNumberInit &&
      dataSource.length > loginDataNumber
    ) {
      return false;
    }
    return true;
  }, [
    dataSource.length,
    loginDataNumber,
    loginNumberInit,
    loginGuide,
    user,
    userReady,
  ]);
  useEffect(() => {
    if (!loginGuideMore) {
      login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginGuideMore]);

  const changeDataLength = useMemoizedFn(() => {
    setDataLength(dataSource.length);
  });

  return (
    <InfiniteScroll
      dataLength={disableMasonry ? dataSource.length : dataLength}
      hasMore={hasMore && loginGuideMore}
      next={onLoadMore}
      className={className}
      loader={
        loadingContent ?? (
          <div className={classNames([styles.loading, "loading"])}>
            <HBLoading size="30px" />
          </div>
        )
      }
      endMessage={endMsg}
      ref={listRef}
      {...(scrollableTarget ? { scrollableTarget } : null)}
      {...infiniteScrollOptions}
      scrollThreshold="800px"
    >
      <If condition={!disableMasonry}>
        <Then>
          <Masonry
            bricks={newDataSource}
            brickId="pin_id"
            render={render}
            ref={masonryRef}
            onRendered={changeDataLength}
            {...masonryOptions}
            {...(scrollableTarget ? { scrollElement: scrollableTarget } : null)}
          >
            {children}
          </Masonry>
        </Then>
        <Else>
          <div className={styles.list} style={listStyle}>
            {renderList}
          </div>
        </Else>
      </If>
    </InfiniteScroll>
  );
}
